import { NgModule } from '@angular/core';
import { HlmDatePickerComponent } from './lib/hlm-date-picker.component';
import { HlmDateRangePickerComponent } from './lib/hlm-date-range-picker.component';

export * from './lib/hlm-date-picker.component';
export * from './lib/hlm-date-picker.token';
export * from './lib/hlm-date-range-picker.component';
export * from './lib/hlm-date-range-picker.token';

export const HlmDatePickerImports = [HlmDatePickerComponent] as const;
export const HlmDateRangePickerImports = [HlmDateRangePickerComponent] as const;

@NgModule({
  imports: [...HlmDatePickerImports, ...HlmDateRangePickerImports],
  exports: [...HlmDatePickerImports, ...HlmDateRangePickerImports],
})
export class HlmDatePickerModule {}
